import React, { useState } from 'react';

const suggestions = [
  '💍 Wedding lehenga under ₹8,000',
  '☀️ Casual summer dress for petite',
  '💼 Office kurta under ₹2,000',
  '🎉 Plus size party wear',
  '🌺 Floral maxi for beach',
  '🌸 Saree for hourglass body',
];

function SearchBar({ onSearch }) {
  const [query, setQuery] = useState('');
  const [activePill, setActivePill] = useState(null);

  const handleSearch = () => {
    if (query.trim()) {
      onSearch(query);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  const handlePillClick = (text) => {
    setActivePill(text);
    setQuery(text);
  };

  return (
    <div style={styles.wrapper}>

      {/* Search Input */}
      <div style={styles.searchContainer}>
        <input
          style={styles.input}
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="e.g. Wedding lehenga under ₹8,000 for hourglass body..."
        />
        <button style={styles.sendBtn} onClick={handleSearch}>
          <span style={{ fontSize: '18px' }}>→</span>
        </button>
      </div>

      {/* Suggestion Pills */}
      <div style={styles.pillsRow}>
        {suggestions.map((s, i) => (
          <div
            key={i}
            style={{
              ...styles.pill,
              ...(activePill === s ? styles.pillActive : {}),
            }}
            onClick={() => handlePillClick(s)}
          >
            {s}
          </div>
        ))}
      </div>

    </div>
  );
}

const styles = {
  wrapper: {
    maxWidth: '700px',
    margin: '0 auto 20px',
    padding: '0 20px',
  },
  searchContainer: {
    position: 'relative',
    marginBottom: '16px',
  },
  input: {
    width: '100%',
    background: 'white',
    border: '1.5px solid #EDE4DA',
    borderRadius: '20px',
    padding: '18px 60px 18px 24px',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '15px',
    color: '#2C2420',
    outline: 'none',
    boxShadow: '0 4px 24px rgba(44,36,32,0.08)',
  },
  sendBtn: {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: '#C8715A',
    border: 'none',
    width: '44px',
    height: '44px',
    borderRadius: '14px',
    cursor: 'pointer',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
  },
  pillsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    justifyContent: 'center',
  },
  pill: {
    background: 'white',
    border: '1px solid #EDE4DA',
    borderRadius: '100px',
    padding: '8px 16px',
    fontSize: '12px',
    color: '#8A7F7A',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  pillActive: {
    background: '#C8715A',
    borderColor: '#C8715A',
    color: 'white',
  },
};

export default SearchBar;